import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
        {
            path: '/mealOpinions',
            name: 'mealOpinions',
            component: resolve => require(['@/view/mealOpinions.vue'], resolve),
        },
		{
			path: '/anhui/dietaryMonitoring',
			name: 'anhuiDietaryMonitoring',
			component: resolve => require(['@/view/anhuiDietaryMonitoring.vue'], resolve),
		},
		{
			path: '/',
			name: 'home',
			component: resolve => require(['@/view/home/home.vue'], resolve),
		},
		{
			path: '/margin',
			name: 'margin',
			component: resolve => require(['@/view/margin.vue'], resolve),
		},
		{
			path: '/operation',
			name: 'operation',
			component: resolve => require(['@/view/operation.vue'], resolve),
		},
		{
			path: '/nutritionTracker',
			name: 'nutritionTracker',
			component: resolve => require(['@/view/nutritionTracker.vue'], resolve),
		},
		{
			path: '/anhui',
			name: 'anhuiCanteen',
			component: resolve => require(['@/view/anhuiCanteen.vue'], resolve),
		},
		{
			path: '/postMealSupervision',
			name: 'postMealSupervision',
			component: resolve => require(['@/view/postMealSupervision.vue'], resolve),
		},
		{
			path: '/videoStream',
			name: 'videoStream',
			component: resolve => require(['@/view/videoStream.vue'], resolve),
		},
		{
			path: '/callScreen',
			name: 'callScreen',
			component: resolve => require(['@/view/callScreen.vue'], resolve),
		},
		{
			path: '/dataCenterDashboard',
			name: 'dataCenterDashboard',
			component: resolve => require(['@/view/dataCenterDashboard.vue'], resolve),
		},
		{
			path: '/electronic-menu-preview',
			name: 'electronicMenuPreview',
			component: resolve => require(['@/view/electronicMenuPreview.vue'], resolve),
		},
		{
			path: '/electronic-menu/:token',
			name: 'electronicMenu',
			component: resolve => require(['@/view/electronicMenu.vue'], resolve),
		},
		{
		
			path: '/stallRanking',
			name: 'stallRanking',
			component: resolve => require(['@/view/stallRanking.vue'], resolve),
		},
		{
			path: '/health',
			name: 'healthKnowledge',
			component: resolve => require(['@/view/healthKnowledge.vue'], resolve),
		},
		{
			path: '/canteenKiosk',
			name: 'canteenKiosk',
			beforeEnter () {
				const basePath = window.location.pathname.replace(/[^/]*$/, '')
				window.location.replace(`${basePath}static/nanjing-site-2f-canteen/index.html#home`)
			},
		},

	],
})



// WEBPACK FOOTER //
// ./src/router/index.js